import BottomSheetDrag from '@components/_Revamp/BottomSheetDrag';
import { Tooltip } from '@components/_Revamp/Tooltip/Tooltip';
import { TooltipBottomSheet } from '@components/_Revamp/TooltipBottomSheet/TooltipBottomSheet';
import { styled } from '@linaria/react';
import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { themeDefault } from 'src/theme-revamp';

interface UnitToolTipProps {
}

const UnitToolTipComponent = forwardRef(({ ...props }: UnitToolTipProps, ref) => {
  const unitToolTipRef = useRef<any>();
  const modalContainerRef = useRef<null | HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    closeMobileTooltip() {
      if (unitToolTipRef) {
        unitToolTipRef.current.close();
      }
    },
    openMobileTooltip() {
      if (unitToolTipRef) {
        unitToolTipRef.current.open();
      }
    },
    openWebTooltip(xCoord: number, yCoord: number) {
      if (modalContainerRef && modalContainerRef.current) {
        let childrens = modalContainerRef.current?.children as HTMLCollectionOf<HTMLElement>;
        if (childrens.length > 0) {
          childrens[0].style.opacity = '1';
          childrens[0].style.left = (xCoord).toString() + 'px';
          childrens[0].style.top = yCoord.toString() + 'px';
        }
        modalContainerRef.current.style.opacity = '1';
      }
    },
    closeWebTooltip() {
      document.body.style.overflowY = 'unset';
      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = '0';
      }
      let childrens = modalContainerRef.current?.children as HTMLCollectionOf<HTMLElement>;
      if (childrens.length > 0) {
        childrens[0].style.opacity = '0';
      }
    },
  }));
  return (
    <>
      <ModalContainer ref={modalContainerRef}>
        <div style={{ opacity: 0, position: 'absolute' }}>
          <Tooltip maxWidth={333} variant="bottom" theme={themeDefault}>
            <UnitTooltipContainer>
              <TootipListingItem>For unit number, please input # followed by numeral digits (e.g. #12-456)</TootipListingItem>
              <TootipListingItem>For P.O. Box, please input numeral digits zero (eg. 0)</TootipListingItem>
              <TootipListingItem>For landed property, please input numeral digits (eg. 00-00)</TootipListingItem>
            </UnitTooltipContainer>
          </Tooltip>
        </div>
      </ModalContainer>

      <MobileModalContainer>
        <BottomSheetDrag ref={unitToolTipRef} overlayClick={() => {
          if (unitToolTipRef) {
            unitToolTipRef.current.close();
          }
        }} isShow={false}>
          <TooltipBottomSheet theme={themeDefault}>
            <React.Fragment>
              <UnitTooltipContainer>
                <TootipListingItem>For unit number, please input # followed by numeral digits (e.g. #12-456)</TootipListingItem>
                <TootipListingItem>For P.O. Box, please input numeral digits zero (eg. 0)</TootipListingItem>
                <TootipListingItem>For landed property, please input numeral digits (eg. 00-00)</TootipListingItem>
              </UnitTooltipContainer>
            </React.Fragment>
          </TooltipBottomSheet>
        </BottomSheetDrag>
      </MobileModalContainer>
    </>
  )
});

export default UnitToolTipComponent


const MobileModalContainer = styled.div`
  display: block;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;


const ModalContainer = styled.div`
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`


const UnitTooltipContainer = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 0px;
  @media screen and (max-width: 768px) {
    row-gap: 0px;
  }
`;

const TootipListingItem = styled.li`
  margin-left: 22px;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 13px;
    left: -13px;
    width: 2px;
    height: 2px;
    border-radius: 100rem;
    background-color: #434343;
  }
`;